import React from "react";
import Download from "../../../assets/icon/Download - Icon 3.svg";

const DownloadCSVButton = ({
  monthsdata,
  valuedata1,
  valuedata2,
  valuedata3,
  heading1,
  filenamedata,
}) => {
  const handleDownload = () => {
    // Data
    const value1 = valuedata1;
    const value2 = valuedata2;
    const months = monthsdata;
    const npi = valuedata3;
    const arr = [];

    //npi in data 
    for (let i = 0; i < value1?.length; i++) {
      if (npi != null) {
        const rownpi = {
          value1: value1[i],   
          Months: (months[i] == null) ? months[i] : months[i].replace(",", ' '),
          // npi:(npi[i] == null) ? npi[i] : npi[i].replace(",", ' '),
          npi: npi[i]

        };
        if (value2 && value2[i] !== undefined) {
          rownpi.value2 = Number(value2[i]).toFixed(2);
          if (heading1?.includes("Dispense Fee Revenue")) {
            rownpi.value2 = `${"$" + Number(value2[i]).toFixed(2)}`
          }
        }
        arr.push(rownpi);
      }
    }

    // Preparing the data
    for (let i = 0; i < value1?.length; i++) {

      if (npi == null || npi == undefined) {

        if (heading1?.includes("Dispense Fee Revenue")) {
          const row = {
            value1: "$" + Number(value1[i]).toFixed(2),
            Months: (months[i] == null) ? months[i] : months[i].replace(",", ' ')
          };
          if (value2 && value2[i] !== undefined) {
            // row.value2 = Number(value2[i]).toFixed(2);
            row.value2 = value2[i] != null ? Number(value2[i]).toFixed(2) : "";


          }

          arr.push(row);
        }
        else {

          const row = {
            value1: Number(value1[i]).toFixed(2),
            Months: (months[i] == null) ? months[i] : months[i].replace(",", ' ')
          };
          if (value2 && value2[i] !== undefined) {
            // row.value2 = Number(value2[i]).toFixed(2);
            row.value2 = value2[i] != null ? Number(value2[i]).toFixed(2) : "";
 
          }

          arr.push(row);


        }

        // Only add value2 if it's available

      }
    }

    // Headers for CSV file
    const headers = heading1;

    // Convert the data into CSV format
    const csvData = arr.reduce((acc, row) => {
      const { Months, value1, value2, npi } = row;

      // Check if value2 exists before adding it to the row
      if (value2 !== undefined) {
        acc.push([Months, value1, value2, npi].join(","));
      }
      else if (npi != undefined) {
        acc.push([npi, Months, value1].join(","));
      }
      else {
        acc.push([Months, value1].join(","));
      }

      return acc;
    }, []);

    // Combine headers and data into the CSV string
    const csvContent = [headers.join(","), ...csvData].join("\n");

    // Triggering the download
    const downloadFile = (data, fileName, fileType) => {
      const blob = new Blob([data], { type: fileType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };

    downloadFile(csvContent, filenamedata, "text/csv");
  };

  return (
    <div>
      <img className="dow_hover" onClick={handleDownload} src={Download} alt="Download CSV" />
      {/* <button>Download CSV File</button> */}
    </div>
  );
};

export default DownloadCSVButton;
